import { Chart } from '@frontend/chart/types';

import { createSingleSeriesTimeSeriesMockData } from '../../../../mocks/create-time-series-mock-data';

export const VENDING_RECYCLE_SPOT_FILL_RATE_LINE_CHART_MOCK_DATA: Chart = createSingleSeriesTimeSeriesMockData({
    days: 30,
    scale: 0.55,
    seriesName: 'Recycle fill rate'
});
